<template>
  <div class="not-line-box">
    <div class="mask"></div>
    <loading />
  </div>
</template>

<script>
import NetworkMixin from '@/mixins/network'
import Loading from '@/components/loading'
import utils from '@/utils/utils'
export default {
  name: 'PageNotline',
  mixins: [NetworkMixin],
  components: {
    Loading
  },
  computed: {
    onLine () {
      return this.netWorkData.onLine
    }
  },
  data () {
    return {
      message: null,
      messageInterval: null,
      messageNumber: 0
    }
  },
  watch: {
    // * 网络监听
    onLine (newValue) {
      if (newValue) {
        if (this.messageInterval) {
          clearInterval(this.messageInterval)
        }
        const { docId, userId } = this.$route.params
        if (docId && userId) {
          if (this.message) {
            this.message.close()
          }
          this.$router.replace({
            path: `/webOnlineEdit/edit/${docId}/${userId}`
          })
        }
      }
    }
  },
  created () {
    this.messageNumber = 0
  },
  mounted () {
    this.onlineRefresh()
    this.setMessage()
  },
  destroyed () {
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
    }
    if (this.message) {
      this.message.close()
    }
  },
  methods: {
    // * 如果用户在这个界面刷新了
    onlineRefresh () {
      if (this.netWorkData.onLine) {
        const { docId, userId } = this.$route.params
        if (docId && userId) {
          this.$router.replace({
            path: `/webOnlineEdit/edit/${docId}/${userId}`
          })
        } else {
          utils.toErrorMessagePage()
        }
      }
    },
    // * 消息提示
    setMessage () {
      if (!this.netWorkData.onLine) {
        this.message = this.$message({
          dangerouslyUseHTMLString: true,
          message:
            '网络异常，文档最新内容会在网络恢复后同步，正在重连<span class="not-line-message-point">...</span>',
          duration: 0,
          type: 'error',
          customClass: 'newsErrorMessage'
        })
        this.messageInterval = setInterval(() => {
          if (this.$route.name === 'PageNotline') {
            this.messageNumber += 1
            const pointDom = document.querySelector('.not-line-message-point')
            if (pointDom) {
              const pointNum = this.messageNumber % 3
              switch (pointNum) {
                case 0:
                  pointDom.innerText = '.'
                  break
                case 1:
                  pointDom.innerText = '..'
                  break
                case 2:
                  pointDom.innerText = '...'
                  break
              }
            }
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.not-line-box {
  position: relative;
  .mask {
    z-index: 2;
    position: fixed;
    width: 100vw;
    height: 100vh;
    // background-color: rgba(255, 255, 255, 0.8);
  }
}
</style>
<style lang="scss">
  .newsErrorMessage{
    top: 8vh !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/error/pageNotline.vue